// must be initialized before tabs
const tabsBackgroundColor = wrapper => {
  wrapper.style.transition = 'background-color 0.4s'
  const classToggles = wrapper.querySelectorAll('[data-class-toggle]')
  classToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      if (toggle.classList.contains('disabled')) return
      classToggles.forEach(currentToggle =>
        wrapper.classList.toggle(
          currentToggle.dataset.classToggle,
          currentToggle === toggle
        )
      )
    })
  })
  if (classToggles[0]) {
    classToggles[0].click()
  }
}

export default tabsBackgroundColor
